import { defineCustomElement } from '@tyler-components-web/core';
import { LabelValueComponent } from './label-value';
export * from './label-value-adapter';
export * from './label-value-constants';
export * from './label-value-foundation';
export * from './label-value';
export function defineLabelValueComponent() {
    defineCustomElement(LabelValueComponent);
}
